import { FEATURE_FLAGS } from 'dashboard/featureFlags';
import { INSTALLATION_TYPES } from 'dashboard/constants/installationTypes';
import { frontendURL } from '../../../../helper/URLHelper';

const BrainAssistantsIndex = () => import('./BrainAssistantsIndex.vue');
const BrainAssistantPage = () => import('./BrainAssistantPage.vue');
const BrainKnowledgeBasesIndex = () => import('./BrainKnowledgeBasesIndex.vue');
const BrainKnowledgeBasePage = () => import('./BrainKnowledgeBasePage.vue');
const BrainOverview = () => import('./BrainOverview.vue');
const BrainCopilotPage = () => import('./BrainCopilotPage.vue');
const BrainConfigPage = () => import('./BrainConfigPage.vue');
const StepIdentity = () => import('./steps/StepIdentity.vue');
const StepCerebro = () => import('./steps/StepCerebro.vue');
const StepFerramentas = () => import('./steps/StepFerramentas.vue');
const StepOperacao = () => import('./steps/StepOperacao.vue');
const StepPlayground = () => import('./steps/StepPlayground.vue');
const StepQuality = () => import('./steps/StepQuality.vue');

const meta = {
  permissions: ['administrator', 'agent'],
  featureFlag: FEATURE_FLAGS.CAPTAIN_V2,
  installationTypes: [INSTALLATION_TYPES.CLOUD, INSTALLATION_TYPES.ENTERPRISE],
};

const metaAdmin = { ...meta, permissions: ['administrator'] };

export const brainRoutes = [
  {
    path: frontendURL('accounts/:accountId/captain/brain'),
    component: BrainAssistantsIndex,
    name: 'brain_assistants_index',
    meta,
  },
  {
    // Visao geral: o cerebro da conta num relance (pilar 1 da area)
    path: frontendURL('accounts/:accountId/captain/brain/overview'),
    component: BrainOverview,
    name: 'brain_overview',
    meta,
  },
  {
    // Copiloto ganhou casa propria na area do brain (configuracao completa);
    // o chat continua no painel da conversa + janela flutuante
    path: frontendURL('accounts/:accountId/captain/brain/copilot'),
    component: BrainCopilotPage,
    name: 'brain_copilot',
    meta: metaAdmin,
  },
  {
    // Sala de maquinas: provedores/modelos + orcamento & uso
    // (o antigo settings/captain redireciona pra ca)
    path: frontendURL('accounts/:accountId/captain/brain/config'),
    component: BrainConfigPage,
    name: 'brain_config',
    meta: metaAdmin,
  },
  {
    // Insights APOSENTADO 2026-08-31 (copiloto absorveu) — nome preservado
    path: frontendURL('accounts/:accountId/captain/brain/insights'),
    name: 'brain_insights',
    redirect: to => ({
      name: 'brain_overview',
      params: { accountId: to.params.accountId },
    }),
  },
  {
    path: frontendURL('accounts/:accountId/captain/brain/knowledge-bases'),
    component: BrainKnowledgeBasesIndex,
    name: 'brain_knowledge_bases_index',
    meta,
  },
  {
    path: frontendURL(
      'accounts/:accountId/captain/brain/knowledge-bases/:knowledgeBaseId'
    ),
    component: BrainKnowledgeBasePage,
    name: 'brain_knowledge_base_show',
    meta,
  },
  {
    path: frontendURL('accounts/:accountId/captain/brain/:assistantId'),
    component: BrainAssistantPage,
    redirect: to => ({
      name: 'brain_wizard_identity',
      params: to.params,
    }),
    children: [
      // 5 passos estrategicos: Perfil / Cerebro / Ferramentas / Operacao /
      // Teste & Qualidade — abas fundidas navegam por sub-abas (?sub=)
      {
        path: 'identity',
        component: StepIdentity,
        name: 'brain_wizard_identity',
        meta,
      },
      {
        path: 'prompt',
        component: StepCerebro,
        name: 'brain_wizard_prompt',
        meta,
      },
      {
        path: 'tools',
        component: StepFerramentas,
        name: 'brain_wizard_tools',
        meta,
      },
      {
        path: 'activation',
        component: StepOperacao,
        name: 'brain_wizard_activation',
        meta,
      },
      {
        path: 'playground',
        component: StepPlayground,
        name: 'brain_wizard_playground',
        meta,
      },
      {
        path: 'quality',
        component: StepQuality,
        name: 'brain_wizard_quality',
        meta,
      },
      // Passos absorvidos pelas abas fundidas — nome preservado (padrao da
      // faxina): caem na aba certa com a sub-aba pre-selecionada
      {
        path: 'knowledge',
        name: 'brain_wizard_knowledge',
        redirect: to => ({
          name: 'brain_wizard_prompt',
          params: to.params,
          query: { sub: 'knowledge' },
        }),
      },
      {
        path: 'flow',
        name: 'brain_wizard_flow',
        redirect: to => ({
          name: 'brain_wizard_tools',
          params: to.params,
          query: { sub: 'flow' },
        }),
      },
      {
        path: 'connect',
        name: 'brain_wizard_connect',
        redirect: to => ({
          name: 'brain_wizard_activation',
          params: to.params,
          query: { sub: 'connect' },
        }),
      },
      // Legacy redirects so old bookmarks/links still work:
      {
        path: 'scripts',
        redirect: to => ({ name: 'brain_wizard_flow', params: to.params }),
      },
      {
        path: 'skills',
        redirect: to => ({ name: 'brain_wizard_tools', params: to.params }),
      },
      {
        path: 'messages',
        redirect: to => ({
          name: 'brain_wizard_activation',
          params: to.params,
          query: { sub: 'activation' },
        }),
      },
      {
        path: 'model',
        redirect: to => ({ name: 'brain_wizard_identity', params: to.params }),
      },
    ],
  },
];
